import { AlertComponent } from ".";


/*Note: need to add session time out logic after session imp.   */
export const DismissAlertComponent = () => {
  return <AlertComponent closeIcon={true} />;
};

export default DismissAlertComponent;
